import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/pages/Home.vue';
const AddAsset = () => import('./components/pages/AddAsset.vue');
const EditAsset = () => import('./components/pages/EditAsset.vue');
const Changelog = () => import('./components/pages/Changelog.vue');
const Terms = () => import('./components/pages/Terms.vue');
const Privacy = () => import('./components/pages/Privacy.vue');
const Contact = () => import('./components/pages/Contact.vue');
const Faq = () => import('./components/pages/Faq.vue');
const Share = () => import('./components/pages/Share.vue');
const Register = () => import('./components/pages/Register.vue');
const Login = () => import('./components/pages/Login.vue');
// const Apikeys = () => import('./components/pages/exchange/Apikeys.vue');
// const Trade = () => import('./components/pages/exchange/Trade.vue');
// const ExchangeInfo = () => import('./components/pages/exchange/Info.vue');
const Blog = () => import('./components/pages/blog/Blog.vue');
const BlogPost = () => import('./components/pages/blog/BlogPost.vue');
const ProfitlossAddTransaction = () => import('./components/pages/profitloss/AddTransaction.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/add',
      name: 'search',
      component: AddAsset,
    },
    {
      path: '/edit/:symbol',
      name: 'edit',
      component: EditAsset,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },
    {
      path: '/changelog',
      name: 'changelog',
      component: Changelog,
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    /*
    {
      path: '/exchange/how-it-works',
      name: 'exchange/info',
      component: ExchangeInfo,
    },
    {
      path: '/exchange/apikeys',
      name: 'exchange/apikeys',
      component: Apikeys,
    },
    {
      path: '/exchange/trade/:exchId/:ticker',
      name: 'exchange/trade',
      component: Trade,
    },
    */
    {
      path: '/blog',
      name: 'blog',
      component: Blog,
    },
    {
      path: '/blog/:blogPost',
      name: 'blogPost',
      component: BlogPost,
    },
    {
      path: '/profitloss/transactions/:transactionId/:pageMode',
      name: 'ProfitlossAddTransaction',
      component: ProfitlossAddTransaction,
    },
    {
      path: '/s/:hash',
      name: 'share',
      component: Share,
    },
    {
      path: '*',
      name: '404',
      component: Home,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
